import service from '@/utils/request'
// 查询询价单
export function srmXjOrderList(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/srmXjOrderList',
		data: param
	})
}
//根据ID查询信息
export function srmXjOrderById(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/srmXjOrderById',
		data: param
	})
}

// 查询询价单 不分页
export function srmXjOrderListAll() {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/list',
	})
}
// 新增询价单
export function addSrmXjOrder(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/add',
		data: param
	})
}
// 修改询价单
export function editSrmXjOrder(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/edit',
		data: param
	})
}

// 批量删除询价单
export function batchDelSrmXjOrder(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/batchDel',
		data: param
	})
}



// 删除询价单
export function delSrmXjOrder(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/del',
		data: param
	})
}
// 导出询价单
export function exportSrmXjOrder(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/export',
		data: param
	})
}
// 获取统计值	采购员
export function getStatistics(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrder/getStatistics',
		data: param
	})
}
// 获取统计值 供应商
export function getStatisticsGys(param) {
	return service.request({
		method: 'POST',
		url: '/app/srmXjOrderUser/getGysStatistics',
		data: param
	})
}
